import request from '@/utils/request';

export function calculate(data) {
  return request({
    url: '/api/guaratee/calculation/calculate',
    method: 'post',
    data,
  });
}


export default { calculate };
